import { ModelConversation, ModelConversationResponse } from 'types/chat';
import { transformMessageResponse } from './transformMessageResponse';

export const transformModelsConversation = (
  models: ModelConversationResponse[],
): ModelConversation[] => {
  return models.map((model) => ({
    id: model.id,
    name: model.name,
    expertRole: model.expertRole,
    messages: model.messages.map(transformMessageResponse),
    order: model.order,
    status: model.modeStatus,
  }));
};
